import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../store';
import { IOfferTermsDispatchProps, IOfferTermsStateProps, OfferTerms } from './index';

import { subscriptionPriceChangesPopupOpen } from '../../store/subscription_price_changes_popup';
import { getHittingMicrodataExperiment } from '../../utils/microdata_experiment';
import { isDealRent } from '../../selectors/isDealRent';
import { isDealRentCianAgency } from '../../utils/dealRentCianAgencyExperiment';

export function mapStateToProps(state: IState): IOfferTermsStateProps {
  const {
    abGroup,
    offerData: { user, agent },
    knAuctionCompanies,
    excludedUtilitiesTermsRegions,
  } = state;

  return {
    abGroup,
    realtyId: agent && agent.realtyUserId ? agent.realtyUserId : undefined,
    isAgent: Boolean(state.offerData.user && state.offerData.user.isAgent),
    isAuthenticated: user && user.isAuthenticated,
    isMicrodataExperimentEnable: getHittingMicrodataExperiment(state.experiments),
    offer: state.offerData.offer,
    subscription: state.offerData.subscription,
    knAuctionCompanies,
    excludedUtilitiesTermsRegions,
    isDealRentCianAgencyEnabled: Boolean(isDealRent(state) && isDealRentCianAgency(state.abUseExperiments)),
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): IOfferTermsDispatchProps {
  return {
    subscriptionPriceChangesPopupOpen: () => {
      dispatch(subscriptionPriceChangesPopupOpen());
    },
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OfferTermsContainer = connect<IOfferTermsStateProps, IOfferTermsDispatchProps, any>(
  mapStateToProps,
  mapDispatchToProps,
)(OfferTerms);
